import { render, staticRenderFns } from "./RegistrationChecklistItems.vue?vue&type=template&id=4c58d992&scoped=true"
import script from "./RegistrationChecklistItems.vue?vue&type=script&lang=js"
export * from "./RegistrationChecklistItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58d992",
  null
  
)

export default component.exports